<script>
  import { onMount, onDestroy } from 'svelte';
  import { createEventDispatcher } from 'svelte';
  export let style

  import SGMSApi from './js/SGMSApi';


  import {language} from './js/AppState'

  const dispatch = createEventDispatcher();

  onMount(() => {
    window.addEventListener("message", onMessage)
  })
  onDestroy(() => {
    window.removeEventListener("message", onMessage)
  })


  function toggleFullscreen() {
    var isFullscreen = document.webkitIsFullScreen || document.mozFullScreen || ( (screen.availHeight || screen.height-30) <= window.innerHeight);
    isFullscreen ? leaveFullscreen() : openFullscreen();
  }


  function openFullscreen() {
    if (document.body.requestFullscreen) {
      document.body.requestFullscreen();
    } else if (document.body.mozRequestFullScreen) { /* Firefox */
      document.body.mozRequestFullScreen();
    } else if (document.body.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
      document.body.webkitRequestFullscreen();
    } else if (document.body.msRequestFullscreen) { /* IE/Edge */
      document.body.msRequestFullscreen();
    }
  }

  function leaveFullscreen() {
    if (document.cancelFullScreen) {
      document.cancelFullScreen();
    } else if (document.mozCancelFullScreen) { /* Firefox */
      document.mozCancelFullScreen();
    } else if (document.webkitCancelFullScreen) { /* Chrome, Safari and Opera */
      document.webkitCancelFullScreen();
    } else if (document.msExitFullscreen) { /* IE/Edge */
      document.msExitFullscreen();
    }
  }

  function max() {
        var wscript = new ActiveXObject("Wscript.shell");
        wscript.SendKeys("{F11}");
    }

  function onMessage(msg) {
    if(msg.data === "endGame") {
      dispatch("gameend")
    }
    else if(msg.data === "setFullscreen") {
      toggleFullscreen()
    }

    else {
      var m = null
      try {
        m = JSON.parse(msg.data)


        if(m)  {


          SGMSApi.sendEvent(m)

        }
      }
      catch(e) {
        console.error(e)

      }
    }
  }


</script>


<iframe style={style} src={window.CONFIG.game_url + "?lang=" + $language} title="game" frameborder="0" allowfullscreen/>

<style>
iframe {
  position: fixed;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  z-index: 3;
}

</style>
